export const Errors: {
    [key: string]: string;
} = {
    "USER.LOGIN_REQUIRED": "Sign in",
    "USER.WRONG_EMAIL_OR_PW": "Invalid email address or password!"
};
